<template>
  <div class="trading-home">
    <div class="trades-title">{{ $t("SmartTrading.smrtTrading") }}</div>
    <div class="trades-menu">
      <div
        class="menu1"
        :class="{ 'menu-active': markTypeIndex === item.realIndex }"
        @click="markTypeChange(item.realIndex)"
        v-for="item in menuList"
        :key="item.realIndex"
      >
        {{ item.label }}
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="box-lists">
      <div class="box-heder">
        <div class="box-heder1">{{ $t("Market.name") }}</div>
        <div class="box-heder4 box-heder4-1">
          {{ $t("Market.SpotPrice") }}
        </div>
        <div class="box-heder3">{{ $t("Market.chart") }}</div>
        <div class="box-heder2">24h%</div>
      </div>
      <div class="box-body">
        <div
          class="box-list"
          style="z-index: 10"
          v-for="(item, index) in marketList"
          :key="index"
          @click="popChange(item)"
        >
          <div class="box-heder1">
            <img :src="item.logo" alt="" srcset="" />
            <span class="name-text">{{ item.appName }}</span>
          </div>
          <div class="box-heder4 box-heder4-1">{{ item.nowPrice }}</div>
          <div class="box-heder3">
            <div class="chart">
              <div class="chart-inner" :id="item.code"></div>
            </div>
          </div>
          <div class="box-heder2" :class="{ 'box-heder2-1': item.zdf > 0 }">
            {{ item.zdf }}%
          </div>
        </div>
      </div>
    </div>

    <SmartBuy @hide="popHide" :marketInfo="marketInfo" v-if="isPop" />
  </div>
</template>

<script>
import { randomLine } from "@/utils/tools.js";
import SmartBuy from "@/components/Smart.vue";
import { listMarketByType, getMarketInfo } from "@/api/market.js";
import { mapGetters } from "vuex";
export default {
  components: {
    SmartBuy,
  },
  data() {
    return {
      isPop: false, //弹窗
      markTypeIndex: 1, // 交易类型：首页仅展示外汇(1)、加密货币(2)，默认外汇
      marketList: [], //交易列表
      chartData: {}, //图表数据
      marketInfo: {}, //交易详情
    };
  },

  computed: {
    ...mapGetters(["getMarkTypeList", "marketWsList", "virtualStatus"]),
    // 首页只展示第2、3个菜单：外汇、加密货币，保留原始下标用于请求
    menuList() {
      return this.getMarkTypeList.map((item, index) => ({
        ...item,
        realIndex: index,
      })).filter((item) => item.value === "1" || item.value === "2");
    },
  },
  watch: {
    marketWsList: {
      handler: function (val) {
        if (val[0]) {
          const data = val;
          this.marketList.forEach((item) => {
            data.forEach((item1) => {
              if (item1.code === item.code) {
                item.nowPrice = item1.price;
                item.zdf = item1.zdf;
              }
            });
          });
          data.forEach((item) => {
            if (!this.chartData[item.code]) {
              this.chartData[item.code] = [];
            }
            this.chartData[item.code].push(item.price);
            this.chartInit(item.code);
          });
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getMarketList();
  },

  methods: {
    popHide() {
      this.isPop = false;
      this.marketInfo = {};
    },
    chartInit(code, hundred = []) {
      // 基于准备好的dom，初始化echarts实例
      let dom = document.getElementById(code);
      if (!dom) {
        return;
      }
      this.$echarts.dispose(document.getElementById(code));
      const myChart = this.$echarts.init(document.getElementById(code));
      // 指定图表的配置项和数据
      var timeData = [];
      var valueData = [];
      // 控制数据长度，只保留最近的 N 个数据
      var maxLength = 100;
      if (hundred.length === 0) {
        timeData = this.chartData[code].map((_, index) => index);
        valueData = this.chartData[code]
          .map((item) => item)
          .filter((item) => item != 0);
        if (timeData.length > maxLength) {
          let num = timeData.length - maxLength;
          for (let i = 0; i < num; i++) {
            timeData.shift();
            valueData.shift();
          }
        }
      } else {
        hundred.forEach((item) => {
          timeData.push(item.time);
          valueData.push(item.price);
        });
        if (timeData.length > maxLength) {
          timeData.shift();
          valueData.shift();
        }
      }
      if (!valueData[0]) {
        valueData = randomLine();
      }
      let red = "#ff2828";
      let green = "#44b400";

      var option = {
        xAxis: {
          type: "category",
          data: timeData,
          show: false,
        },
        grid: {
          left: "10%",
          right: "10%",
          top: "10%",
          bottom: "10%",
        },
        yAxis: {
          type: "value",
          show: false,
          max: function () {
            return Math.max.apply(null, valueData);
          },
          min: function () {
            return Math.min.apply(null, valueData);
          },
        },
        series: [
          {
            type: "line",
            data: valueData,
            symbol: "none",
            animation: false,
            itemStyle: {
              color:
                this.marketList.find((item) => item.code === code).zdf > 0
                  ? red
                  : green,
            },
            lineStyle: {
              width: 1,
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    async getMarketList() {
      let type = this.getMarkTypeList[this.markTypeIndex].value;
      const res = await listMarketByType({
        type: type,
        canSmart: "1",
      });
      this.marketList = res.result;
      this.marketList.forEach((item, index) => {
        if (type == 1 && item.code == "XAUUSD") {
          console.log(item, "XAUUSD");
          this.marketList.splice(index, 1);
        }
      });
      this.marketList.forEach((item, index) => {
        this.marketList[index].nowPrice = item.price;
        this.chartData[item.code] = item.hundred;
        setTimeout(() => {
          this.chartInit(item.code);
        });
      });
    },
    markTypeChange(index) {
      this.markTypeIndex = index;
      this.marketList = [];
      this.getMarketList();
    },
    popChange(item) {
      if (this.virtualStatus != 1) {
        this.$message({
          message: this.$t("yanShiZhangHaoBuNengShiYongGaiGongNeng"),
          type: "warning",
        });
        return;
      }
      getMarketInfo(item.id).then((res) => {
        let result = res.result;
        // 部分品种无智能交易配置（smartInfo 为 null），直接打开弹窗会报错
        if (!result || !result.smartInfo || !result.smartInfo.smartInfo) {
          this.$message({
            message: this.$t("gaiPinZhongZanBuZhiChiZhiNengJiaoYi"),
            type: "warning",
          });
          return;
        }
        result.smartInfo.smartInfo = JSON.parse(result.smartInfo.smartInfo);
        this.marketInfo = result;
        this.isPop = true;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.trading-home {
  width: 100%;
}

.trades-title {
  width: 100%;
  height: 0.52rem;
  font-size: 0.52rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  text-align: center;
  margin-top: 0.6rem;
}

.trades-menu {
  margin: auto;
  width: max-content;
  background: #1a2a44;
  border-radius: 0.2rem;
  margin-top: 0.26rem;
  margin-bottom: 0.36rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 0.16rem;
  line-height: 100%;
  padding: 0.08rem 0.08rem;
}

.trades-menu .menu1 {
  float: left;
  padding: 0 0.24rem;
  line-height: 0.52rem;
  color: #949494;
  font-family: Mabry Pro;
  cursor: pointer;
}

.trades-menu .menu-active {
  font-family: Mabry Pro;
  height: 0.52rem;
  background: #152238;
  box-shadow: 0 0.1rem 0.14rem rgba(0, 0, 0, 0.12);
  border-radius: 0.16rem;
  padding: 0 0.24rem;
  text-align: center;
  line-height: 0.52rem;
  color: #fff;
}

/* 首页嵌入（仅在移动端 .content 渲染，容器约 3.3rem 宽）：
   列宽用百分比，随窄屏自适应，表头与表体共用同一组比例保证垂直对齐 */
$col-price: 21%; // 现价
$col-chart: 18%; // 走势图
$col-zdf: 17%; // 24h 涨跌幅

.box-lists {
  width: 100%;
  margin: auto;
  margin-top: 0.4rem;
  margin-bottom: 0.8rem;
}

.box-lists .box-heder {
  width: 100%;
  height: 0.44rem;
  display: flex;
  align-items: center;
  column-gap: 0.08rem;
  padding: 0 0.12rem;
  box-sizing: border-box;
  font-family: Mabry Pro;
  font-size: 0.14rem;
  color: rgba(255, 255, 255, 0.6);
}

.box-lists .box-heder .box-heder1 {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}

.box-lists .box-heder .box-heder4 {
  flex: 0 0 $col-price;
  width: $col-price;
  text-align: right;
}

.box-lists .box-heder .box-heder3 {
  flex: 0 0 $col-chart;
  width: $col-chart;
  text-align: right;
}

.box-lists .box-heder .box-heder2 {
  flex: 0 0 $col-zdf;
  width: $col-zdf;
  text-align: right;
}

.box-lists .box-body .box-list {
  width: 100%;
  height: 0.84rem;
  background: #152238;
  box-shadow: 0 0.34rem 0.44rem rgba(0, 0, 0, 0.08);
  border-radius: 0.16rem;
  margin-bottom: 0.16rem;
  display: flex;
  align-items: center;
  column-gap: 0.08rem;
  padding: 0 0.12rem;
  box-sizing: border-box;
  cursor: pointer;
}

.box-lists .box-body .box-list .box-heder1 {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  font-family: Mabry Pro;
  font-size: 0.15rem;
  font-weight: 700;
  color: #fff;
}

.box-lists .box-body .box-list .box-heder1 img {
  width: 0.28rem;
  height: 0.28rem;
  flex: 0 0 0.28rem;
  object-fit: contain;
  max-width: none;
  margin-right: 0.08rem;
}

.box-lists .box-body .box-list .box-heder1 .name-text {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.box-lists .box-body .box-list .box-heder4 {
  flex: 0 0 $col-price;
  width: $col-price;
  text-align: right;
  white-space: nowrap;
  font-family: Mabry Pro;
  font-size: 0.14rem;
  color: rgba(255, 255, 255, 0.5);
}

.box-lists .box-body .box-list .box-heder3 {
  flex: 0 0 $col-chart;
  width: $col-chart;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.box-lists .box-body .box-list .box-heder3 .chart {
  width: 100%;
  height: 0.48rem;
}

.box-lists .box-body .box-list .box-heder3 .chart-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.box-lists .box-body .box-list .box-heder2 {
  flex: 0 0 $col-zdf;
  width: $col-zdf;
  text-align: right;
  white-space: nowrap;
  font-family: Mabry Pro;
  font-size: 0.14rem;
  font-weight: 500;
  color: #44b400;
}

.box-lists .box-body .box-list .box-heder2-1 {
  color: #ff2828;
}
</style>
